import { render, staticRenderFns } from "./BoostRobotList.vue?vue&type=template&id=0db3ae8c"
import script from "./BoostRobotList.vue?vue&type=script&lang=js"
export * from "./BoostRobotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports